/** An HTTP endpoint (and the fallback for any platform that cannot discover): a path plus declared inputs. */

import { GenericRunSettingsForm } from "../run-settings-form";
import type { PlatformScreens } from "../screens";
import { declaredInputs, declaredSpec, fromRef, parseSchema } from "./declared";
import { HttpTargetPicker } from "./target-picker";

export const httpScreens: PlatformScreens = {
  TargetPicker: HttpTargetPicker,
  RunSettingsForm: GenericRunSettingsForm,
  discovers: false,
  fromRef,
  ready: (t) =>
    !!t.path?.trim() && declaredInputs(t).length > 0 && typeof parseSchema(t.schemaText) !== "string",
  payload: (t) => {
    const schema = parseSchema(t.schemaText);
    return {
      version: t.version,
      external_ref: { path: t.path?.trim() ?? "" },
      inputs: declaredInputs(t),
      output_schema: typeof schema === "string" ? null : schema,
      task: t.task?.trim() ?? "",
      ...(t.agentName?.trim() ? { agent_name: t.agentName.trim() } : {}),
    };
  },
  declaredSpec,
};
